import { SELECT_VEHICLEID } from '../types/formTypes'

export const selectVehicleId = (id) => (dispatch) => {
    dispatch({ type: SELECT_VEHICLEID, payload: id })
}